"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoAIPresenter = void 0;
class AutoAIPresenter {
    viewModel;
    constructor() { }
    setViewModel(viewModel) {
        this.viewModel = viewModel;
    }
    setIsLoading(isLoading) {
        if (!this.viewModel) {
            return;
        }
        this.viewModel.isLoading = isLoading;
    }
    setIsVisible(isVisible) {
        if (!this.viewModel) {
            return;
        }
        this.viewModel.isVisible = isVisible;
    }
    setShowRoles(value) {
        if (!this.viewModel) {
            return;
        }
        this.viewModel.showRoles = value;
    }
    setCheckedRoles(ids) {
        if (!this.viewModel) {
            return;
        }
        this.viewModel.checkedRoles = [...ids];
    }
    toggleAllCheckedRoles(selectAll) {
        if (!this.viewModel) {
            return;
        }
        if (selectAll) {
            this.viewModel.checkedRoles = (this.viewModel.roles ?? []).map(r => r.getOriginalId());
        }
        else {
            this.viewModel.checkedRoles = [];
        }
    }
    setIntructions(text) {
        if (!this.viewModel) {
            return;
        }
        this.viewModel.instructions = text;
    }
    setTaskDone(isDone, notesJapanese) {
        if (!this.viewModel) {
            return;
        }
        this.viewModel.isDone = isDone;
        this.viewModel.notesJapanese = notesJapanese || "";
    }
    setReloadOnDone(reload) {
        if (!this.viewModel) {
            return;
        }
        this.viewModel.reloadOnDone = reload;
    }
    setPromptHistory(history) {
        if (!this.viewModel) {
            return;
        }
        this.viewModel.promptHistory = [...history];
    }
    addPromptHistory(prompt) {
        if (!this.viewModel) {
            return;
        }
        this.viewModel.promptHistory = [prompt, ...(this.viewModel.promptHistory || [])];
    }
    updatePromptHistory(prompt) {
        if (!this.viewModel) {
            return;
        }
        const index = this.viewModel.promptHistory.findIndex(p => p.id === prompt.id);
        if (index === -1) {
            return;
        }
        this.viewModel.promptHistory[index] = prompt;
        this.viewModel.promptHistory.sort((a, b) => b.date.localeCompare(a.date));
    }
    deletePromptHistory(promptId) {
        if (!this.viewModel) {
            return;
        }
        this.viewModel.promptHistory = this.viewModel.promptHistory.filter(p => p.id !== promptId);
        if (this.viewModel.selectedPromptId === promptId) {
            this.viewModel.selectedPromptId = "";
        }
    }
    selectPrompt(prompt) {
        if (!this.viewModel) {
            return;
        }
        this.viewModel.instructions = prompt.message;
        this.viewModel.selectedPromptId = prompt.id;
    }
    clear() {
        this.setTaskDone(false, "");
        this.setShowRoles(true);
        this.setIsLoading(false);
        this.toggleAllCheckedRoles(false);
        this.setReloadOnDone(true);
    }
}
exports.AutoAIPresenter = AutoAIPresenter;
